import { create } from "zustand";
import { createJSONStorage, devtools, persist } from "zustand/middleware";
import { ILikeProductsStateAndAction, initialState } from "./initialState";
import { getLikeProducts } from "@/src/models/products";
export const useLikeProductListStore = create<ILikeProductsStateAndAction>()(
    devtools(
        persist(
            (set, get) => ({
                ...initialState,
                getLikeProduct: async (id: number) => {
                    const result = await getLikeProducts(id);
                    const res = result.map((item: any) => {
                        item.area_id = item.products_id;
                        item.link = `/productDetail/${item.products_id}?master_categories_id=${item.master_categories_id}`;
                        return item;
                    });
                    set({
                        likeProductsList: res,
                        isLoading: false,
                        error: "",
                    });
                },
            }),
            {
                name: "like-productsList-storage",
                storage: createJSONStorage(() => sessionStorage),
            },
        ),
        {
            name: "like-productsList-store",
        },
    ),
);
